export default {
    getGrids: { method: 'get', url: 'grids' },
    postGrids: { method: 'post', url: 'grids' },
    putGrids: { method: 'put', url: 'grids/{id}' },
    deleteGrids: { method: 'delete', url: 'grids/{id}' },
}
